import { IconButton } from '@mui/material';
// Hooks
import { useMarketingFunnel } from '@/hooks/useMarketingFunnel';
import { useIsMobile } from '@/hooks/useIsMobile';

export default function SocialMediaButton({
  shareLink,
  socialIcon,
  supported,
  setSupported,
}): JSX.Element {
  const isMobile = useIsMobile(820);
  const { handleSetEngageTag } = useMarketingFunnel();

  const handleSocialClick = (): void => {
    handleSetEngageTag(['share-link-active']);
    if (navigator.share) {
      navigator
        .share({
          title: 'Join me today',
          url: shareLink,
        })
        .catch(() => {
          setSupported(false);
        });
    } else {
      setSupported(false);
    }
  };

  if (isMobile && supported) {
    return (
      <IconButton
        data-core-qa={socialIcon.dataTag}
        onClick={handleSocialClick}
        sx={{
          backgroundColor: socialIcon.backgroundColor,
          '&:hover': {
            backgroundColor: `${socialIcon.backgroundColor}aa`,
          },
        }}
      >
        <img
          src={socialIcon.buttonLogo}
          alt="social media icon"
          style={{ width: '16px', height: '16px' }}
        />
      </IconButton>
    );
  }
  return (
    <a target="_blank" rel="noreferrer" href={socialIcon.socialDataURL}>
      <IconButton
        data-core-qa={socialIcon.dataTag}
        sx={{
          backgroundColor: socialIcon.backgroundColor,
          '&:hover': {
            backgroundColor: `${socialIcon.backgroundColor}aa`,
          },
        }}
      >
        <img
          src={socialIcon.buttonLogo}
          alt="social media icon"
          style={{ width: '16px', height: '16px' }}
        />
      </IconButton>
    </a>
  );
}
